// extracted by mini-css-extract-plugin
export var divider = "_kc-0";
export var systemMessage = "_kc-1";
export var systemMessageWrapper = "_kc-2";